import Keycloak from 'keycloak-js';
import { Dispatch } from 'redux';

import { loadInitKeycloak } from 'src/redux/features/initilizationKeycloak/actions';
import { createCookieInHour } from 'src/utils';
import {
  clientIdKeycloak,
  intervalUpdateToken,
  realmIdKeycloak,
  updateTokenSecondBefore,
} from 'src/utils/config';

// @ts-ignore
const kc = new Keycloak({
  url: process.env.REACT_APP_API_KEYCLOAK,
  realm: realmIdKeycloak,
  clientId: clientIdKeycloak,
}) as Keycloak.KeycloakInstance;

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 */
const initKeycloak = (dispanch: Dispatch<any>) => {
  kc.init({
    onLoad: 'login-required',
  })
    .then((authenticated: any) => {
      if (!authenticated) {
        console.log('user is not authenticated..!');
      }
      createCookieInHour('token', `Bearer ${kc.token}`);
      createCookieInHour('refresh-token', kc.refreshToken, 8760);
      dispanch(loadInitKeycloak());
      setInterval(() => {
        updateToken()
          .then((refreshed) => {
            if (refreshed) {
              createCookieInHour('token', `Bearer ${kc.token}`);
            }
          })
          .catch(() => {
            UserService.doLogout();
          });
      }, Number(intervalUpdateToken));
    })
    .catch(console.error);
};

const doLogin = () => kc.login();

const doLogout = () => kc.logout();

const getToken = () => kc.token;

const profileInfo = () => kc.profile;

const getUserProfile = () => kc.loadUserProfile();

const getUserInfo = () => kc.loadUserInfo();

const isLoggedIn = () => !!kc.token;

// @ts-ignore
const updateToken = () => {
  return kc.updateToken(Number(updateTokenSecondBefore));
};

const getUsername = () => kc.tokenParsed?.preferred_username;

const hasRole = (roles: any[]) => roles.some((role) => kc.hasRealmRole(role));

const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  profileInfo,
  getUserProfile,
  getUserInfo,
  updateToken,
  getUsername,
  hasRole,
};

export default UserService;
